import { useState } from "react";

export const useTags = (tags: string[], limit: number) => {
  const limitedTags = tags.slice(0, limit);
  const remainingTagsCount = tags.length - limit;
  const remainingTags = tags.slice(limit);
  const [showRemainingTags, setShowRemainingTags] = useState(false);

  return {
    limitedTags,
    remainingTagsCount,
    remainingTags,
    showRemainingTags,
    setShowRemainingTags,
  };
};
